import { useState } from "react";
import axios from "axios";

function App() {
  const [counter, setCounter] = useState(0)

  const callAPI = async (endpoint) => {
    try {
      const response = await axios.post(
        `/api/${endpoint}`, // Для продакшена замените на URL сервера
        { number: counter }
      );
      setCounter(response.data.result);
    } catch (error) {
      console.error('Ошибка:', error.response?.data?.error || error.message);
    }
  };

  return (
    <div className="App">
      <h1>Counter:{counter}</h1>
      <button onClick={() => callAPI('increment')}>increment</button>
      <button onClick={() => callAPI('decrement')}>decrement</button>
    </div>
  );
}

export default App;
